<template>
  <a-layout-footer class="default-footer text-center">
    <a-row type="flex" justify="center" :gutter="[0, 40]">
      <a-col :xs="16" :sm="8" :md="6" :lg="4" :xl="3" :order="imgOrder">
        <img
          class="default-footer__logo"
          src="/static/img/wt-white.png"
          alt="Logo webtraining.zone"
        />
      </a-col>
      <a-col :xs="24" :sm="16" :md="18" :lg="20" :xl="21" :order="textOrder">
        <p class="default-footer__text">
          Creado con mucho entusiasmo por Webtraning.Zone
        </p>
      </a-col>
    </a-row>
  </a-layout-footer>
</template>

<script>
export default {
  methods: {},
  computed: {
    // Invert order of elements
    imgOrder() {
      return ['xs', 'sm'].includes(this.$mq) ? 2 : 1;
    },
    textOrder() {
      return ['xs', 'sm'].includes(this.$mq) ? 1 : 2;
    },
  },
};
</script>

<style lang="scss" scoped>
.default {
  &-footer {
    min-height: 200px;

    background: #18bc9c;
    color: #fff;

    &__logo {
      width: 100%;
    }

    &__text {
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.46);

      @media screen and (min-width: 576px) {
        text-align: right;
      }
    }
  }
}
</style>
